import { useQuery, UseQueryOptions } from 'react-query';

import { UsersQueryApi } from '@lib/api/endpoints';

export const useGetUserAppearance = (
  userId: number,
  options?: UseQueryOptions<
    UserAppearance,
    unknown,
    UserAppearance,
    (string | number)[]
  >
) => {
  const { data, isLoading, isError, isFetching } = useQuery({
    queryKey: ['userAppearance', userId],
    queryFn: () => UsersQueryApi.getUserAppearance(userId),
    enabled: !!userId,
    ...options,
  });

  return {
    data,
    isLoading,
    isError,
    isFetching,
  };
};
